import { toNumber } from '@freelancer/utils';
import type { EntryRestrictionsGetResultAjax } from './entry-restrictions.backend-model';
import type { EntryRestrictions } from './entry-restrictions.model';

export function transformEntryRestrictions(
  restrictions: EntryRestrictionsGetResultAjax,
  authUid: string,
): EntryRestrictions {
  if (restrictions.requirements.complete) {
    return {
      id: toNumber(authUid),
      requirements: {
        complete: true,
      },
    };
  }

  return {
    id: toNumber(authUid),
    requirements: {
      complete: false,
      profile: {
        hasFullname: restrictions.requirements.profile.hasFullname,
        hasAddress: restrictions.requirements.profile.hasAddress,
        hasProfilePicture: restrictions.requirements.profile.hasProfilePicture,
        displayName: restrictions.requirements.profile.displayName,
        username: restrictions.requirements.profile.username,
      },
      trust: {
        hasVerifiedEmail: restrictions.requirements.trust.hasVerifiedEmail,
        hasVerifiedPhone: restrictions.requirements.trust.hasVerifiedPhone,
        hasFacebook: restrictions.requirements.trust.hasFacebook,
        hasLinkedIn: restrictions.requirements.trust.hasLinkedIn,
        hasVerifiedCard: restrictions.requirements.trust.hasVerifiedCard,
        isKycVerified: restrictions.requirements.trust.isKYCVerified,
        minimumRequired: restrictions.requirements.trust.minimumRequired,
        points: {
          email: restrictions.requirements.trust.points.email,
          phone: restrictions.requirements.trust.points.phone,
          ccv: restrictions.requirements.trust.points.ccv,
          kyc: restrictions.requirements.trust.points.kyc,
          facebook: restrictions.requirements.trust.points.facebook,
          linkedin: restrictions.requirements.trust.points.linkedin,
        },
        score: restrictions.requirements.trust.score,
        targetPoints: restrictions.requirements.trust.targetPoints,
        showCcv: restrictions.requirements.trust.showCCV,
      },
    },
  };
}
